import React, { useState } from 'react';
import { Form, Input, Button, Select, Layout, Typography, Spin, Row, Col, Checkbox, message, Card, Divider } from 'antd';
import { UserOutlined, MailOutlined, DesktopOutlined, LockOutlined, BankOutlined, GlobalOutlined, RocketOutlined, ToolOutlined, SafetyOutlined, ApiOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { BASE_URL } from '../Components/Constant';
import ApiService from '../Components/apiService';
import { useNavigate } from 'react-router-dom';
import { COUNTRY_OPTIONS } from "../Components/Constant";


const { Content } = Layout;
const { Title, Text } = Typography;
const { Option } = Select;

const CreateOrg = () => {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [isAgreed, setIsAgreed] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    // Add CSS animations
    React.useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = `
            @keyframes float {
                0%, 100% { transform: translateY(0px); }
                50% { transform: translateY(-20px); }
            }
            @keyframes fadeInUp {
                from {
                    opacity: 0;
                    transform: translateY(30px);
                }
                to {
                    opacity: 1;
                    transform: translateY(0);
                }
            }
            .animate-fadeInUp {
                animation: fadeInUp 0.6s ease forwards;
            }
        `;
        document.head.appendChild(style);
        
        // Trigger animations
        setTimeout(() => setIsVisible(true), 100);
        
        return () => {
            if (document.head.contains(style)) {
                document.head.removeChild(style);
            }
        };
    }, []);

    const handleFinish = async (values) => {
        console.log(values);
        const country = values.country;
        const selectedCountry = COUNTRY_OPTIONS.find((item) => item.value === country);

        const body = {
            
                "org_info": {
                    name: values.name,
                    first_name: values.first_name,
                    last_name: values.last_name,
                    username: values.username,
                    category: values.category,
                    instance_url: "https://aptclouds.org",
                    contact_email: values.contact_email,
                    status:"active",
                    currency: selectedCountry?.currency?.symbol || '$',
                    currency_details: selectedCountry?.currency || {},
                    defaultLocale: (country === 'usa' || country === 'other') ? 'United_States' : country === 'india' ? 'India' : 'United_Kingdom',
                    defaultLanguage: 'English',
                    defaultTimezone: (country === 'usa' || country === 'other' || country === 'uk') ? 'UTC' : 'IST',
                    gridView: true,
                    org_type: "production",
                }
        };
        

        console.log(body);
        try {
            setLoading(true);
            const apiService = new ApiService(`${BASE_URL}/org_infos`, {
                'Content-Type': 'application/json', // Add any necessary headers, such as content type
            }, 'POST', body
            );

            const response = await apiService.makeCall();

            message.success("Org created successfully!");

            navigate('/login');


        } catch (error) {
            console.error("Error creating organization:", error);
        } finally {
            setLoading(false);
        }

    };

    return (
        <div
            style={{
                minHeight: "100vh",
                background: "linear-gradient(135deg, #1D3557 0%, #457B9D 50%, #FCD6C7 100%)",
                position: "relative",
                overflow: "hidden",
            }}
        >
            <Spin spinning={loading} size="large" tip="Creating your organization...">
                {/* Background decorative elements */}
                <div
                    style={{
                        position: "absolute",
                        top: "-50px",
                        right: "-50px",
                        width: "200px",
                        height: "200px",
                        borderRadius: "50%",
                        background: "rgba(254, 114, 0, 0.1)",
                        animation: "float 6s ease-in-out infinite",
                    }}
                />
                <div
                    style={{
                        position: "absolute",
                        bottom: "-100px",
                        left: "-100px",
                        width: "300px",
                        height: "300px",
                        borderRadius: "50%",
                        background: "rgba(255, 255, 255, 0.05)",
                        animation: "float 8s ease-in-out infinite reverse",
                    }}
                />

                {/* Header */}
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        padding: "20px 40px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        background: "rgba(255, 255, 255, 0.1)",
                        backdropFilter: "blur(10px)",
                        borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
                    }}
                >
                    <div
                        style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            color: "#FFFFFF",
                            opacity: isVisible ? 1 : 0,
                            transform: isVisible ? "translateY(0)" : "translateY(-20px)",
                            transition: "all 0.8s ease",
                        }}
                    >
                        Aptify
                    </div>
                    {/* <Button
                        type="text"
                        onClick={() => navigate("/login")}
                        style={{
                            color: "#FFFFFF",
                            border: "1px solid rgba(255, 255, 255, 0.3)",
                            borderRadius: "6px",
                            opacity: isVisible ? 1 : 0,
                            transform: isVisible ? "translateY(0)" : "translateY(-20px)",
                            transition: "all 0.8s ease 0.2s",
                        }}
                    >
                        Back to Login
                    </Button> */}
                </div>

                <Row style={{ minHeight: "100vh", paddingTop: "80px" }}>
                    {/* Left: Form */}
                    <Col
                        xs={24}
                        lg={14}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "40px",
                        }}
                    >
                        <div
                            style={{
                                width: "100%",
                                maxWidth: "600px",
                                borderRadius: "20px",
                                boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
                                border: "1px solid rgba(255, 255, 255, 0.1)",
                                background: "rgba(255, 255, 255, 0.95)",
                                backdropFilter: "blur(20px)",
                                padding: "40px",
                                opacity: isVisible ? 1 : 0,
                                transform: isVisible ? "translateY(0) scale(1)" : "translateY(30px) scale(0.9)",
                                transition: "all 1s ease 0.3s",
                            }}
                        >
                            <div style={{ textAlign: "center", marginBottom: "30px" }}>
                                <Title level={2} style={{ color: "#1D3557", marginBottom: "8px", fontSize: "28px" }}>
                                    Create Your Organization
                                </Title>
                                <Text style={{ color: "#457B9D", fontSize: "16px" }}>
                                    Complete the form to set up your enterprise workspace
                                </Text>
                            </div>

                            <Form
                                form={form}
                                layout="vertical"
                                onFinish={handleFinish}
                                style={{ marginTop: "20px" }}
                            >
                                <Row gutter={16}>
                                    <Col span={12}>
                                        <Form.Item
                                            label={<span style={{ color: "#1D3557", fontWeight: "500" }}>First Name</span>}
                                            name="first_name"
                                            rules={[{ required: true, message: 'Please enter your first name' }]}
                                        >
                                            <Input 
                                                prefix={<UserOutlined style={{ color: "#457B9D" }} />}
                                                placeholder="Your first name" 
                                                size="large"
                                                style={{
                                                    borderRadius: "8px",
                                                    border: "2px solid #f0f0f0",
                                                    transition: "all 0.3s ease",
                                                }}
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = "#FE7200";
                                                    e.target.style.boxShadow = "0 0 0 2px rgba(254, 114, 0, 0.1)";
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = "#f0f0f0";
                                                    e.target.style.boxShadow = "none";
                                                }}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item
                                            label={<span style={{ color: "#1D3557", fontWeight: "500" }}>Last Name</span>}
                                            name="last_name"
                                            rules={[{ required: true, message: 'Please enter your last name' }]}
                                        >
                                            <Input 
                                                placeholder="Your last name" 
                                                size="large"
                                                style={{
                                                    borderRadius: "8px",
                                                    border: "2px solid #f0f0f0",
                                                    transition: "all 0.3s ease",
                                                }}
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = "#FE7200";
                                                    e.target.style.boxShadow = "0 0 0 2px rgba(254, 114, 0, 0.1)";
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = "#f0f0f0";
                                                    e.target.style.boxShadow = "none";
                                                }}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>

                                <Form.Item
                                    label={<span style={{ color: "#1D3557", fontWeight: "500" }}>Email Address</span>}
                                    name="contact_email"
                                    rules={[{ required: true, type: 'email', message: 'Please enter a valid email' }]}
                                >
                                    <Input 
                                        prefix={<MailOutlined style={{ color: "#457B9D" }} />}
                                        placeholder="you@company.com" 
                                        size="large"
                                        style={{
                                            borderRadius: "8px",
                                            border: "2px solid #f0f0f0",
                                            transition: "all 0.3s ease",
                                        }}
                                        onFocus={(e) => {
                                            e.target.style.borderColor = "#FE7200";
                                            e.target.style.boxShadow = "0 0 0 2px rgba(254, 114, 0, 0.1)";
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.borderColor = "#f0f0f0";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    />
                                </Form.Item>

                                <Form.Item
                                    label={<span style={{ color: "#1D3557", fontWeight: "500" }}>Username</span>}
                                    name="username"
                                    rules={[{ required: true, message: 'Please enter a username' }]}
                                >
                                    <Input 
                                        prefix={<UserOutlined style={{ color: "#457B9D" }} />}
                                        placeholder="Choose a username" 
                                        size="large"
                                        style={{
                                            borderRadius: "8px",
                                            border: "2px solid #f0f0f0",
                                            transition: "all 0.3s ease",
                                        }}
                                        onFocus={(e) => {
                                            e.target.style.borderColor = "#FE7200";
                                            e.target.style.boxShadow = "0 0 0 2px rgba(254, 114, 0, 0.1)";
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.borderColor = "#f0f0f0";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    />
                                </Form.Item>

                                <Form.Item
                                    label={<span style={{ color: "#1D3557", fontWeight: "500" }}>Company Name</span>}
                                    name="name"  
                                    rules={[{ required: true, message: 'Please enter your Company name' }]}
                                >
                                    <Input 
                                        prefix={<BankOutlined style={{ color: "#457B9D" }} />}
                                        placeholder="Your company name" 
                                        size="large"
                                        style={{
                                            borderRadius: "8px",
                                            border: "2px solid #f0f0f0",
                                            transition: "all 0.3s ease",
                                        }}
                                        onFocus={(e) => {
                                            e.target.style.borderColor = "#FE7200";
                                            e.target.style.boxShadow = "0 0 0 2px rgba(254, 114, 0, 0.1)";
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.borderColor = "#f0f0f0";
                                            e.target.style.boxShadow = "none";
                                        }}
                                    />
                                </Form.Item>

                                <Row gutter={16}>
                                    <Col span={12}>
                                        <Form.Item
                                            label={<span style={{ color: "#1D3557", fontWeight: "500" }}>Business Category</span>}
                                            name="category"
                                            rules={[{ required: true, message: 'Please select your business category' }]}
                                        >
                                            <Select 
                                                placeholder="Select business category"
                                                size="large"
                                                style={{
                                                    borderRadius: "8px",
                                                }}
                                            >
                                                <Option value="technology">Technology</Option>
                                                <Option value="finance">Finance</Option>
                                                <Option value="healthcare">Healthcare</Option>
                                                <Option value="education">Education</Option>
                                                <Option value="retail">Retail</Option>
                                                <Option value="manufacturing">Manufacturing</Option>
                                                <Option value="hospitality">Hospitality</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item
                                            label={<span style={{ color: "#1D3557", fontWeight: "500" }}>Country/Region</span>}
                                            name="country"
                                            rules={[{ required: true, message: 'Please select your country' }]}
                                        >
                                            <Select 
                                                showSearch 
                                                placeholder="Select country"
                                                size="large"
                                                style={{
                                                    borderRadius: "8px",
                                                }}
                                            >
                                                {COUNTRY_OPTIONS.map((country) => (
                                                    <Select.Option key={country.value} value={country.value}>
                                                        {country.label}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>

                                <Form.Item
                                    name="agreement"
                                    valuePropName="checked"
                                    rules={[
                                        {
                                            validator: (_, value) =>
                                                value ? Promise.resolve() : Promise.reject(new Error('Please check this box if you want to proceed')),
                                        },
                                    ]}
                                    style={{ marginTop: "20px" }}
                                >
                                    <Checkbox 
                                        onChange={(e) => setIsAgreed(e.target.checked)}
                                        style={{ color: "#1D3557" }}
                                    >
                                        I agree to the <Link to="/terms">Services Agreement</Link> and <Link to="/privacy">Privacy Policy</Link>
                                    </Checkbox>
                                </Form.Item>

                                <Form.Item style={{ marginBottom: "20px" }}>
                                    <Button 
                                        type="primary" 
                                        htmlType="submit" 
                                        block 
                                        size="large"
                                        loading={loading}
                                        style={{
                                            backgroundColor: "#FE7200",
                                            borderColor: "#FE7200",
                                            borderRadius: "8px",
                                            height: "50px",
                                            fontSize: "16px",
                                            fontWeight: "600",
                                            boxShadow: "0 4px 12px rgba(254, 114, 0, 0.3)",
                                            transition: "all 0.3s ease",
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = "#e85d00";
                                            e.currentTarget.style.transform = "translateY(-2px)";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = "#FE7200";
                                            e.currentTarget.style.transform = "translateY(0)";
                                        }}
                                    >
                                        {loading ? <Spin /> : "Create Organization"}
                                    </Button>
                                </Form.Item>
                            </Form>

                            <div style={{ textAlign: "center", marginTop: "20px" }}>
                                <Text style={{ color: "#457B9D" }}>
                                    Already have an account? <Link to="/login" style={{ color: "#FE7200", fontWeight: "500" }}>Sign In</Link>
                                </Text>
                            </div>
                        </div>
                    </Col>

                    {/* Right: Features */}
                    <Col
                        xs={24}
                        lg={10}
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            padding: "60px 40px",
                            background: "rgba(255, 255, 255, 0.05)",
                            backdropFilter: "blur(10px)",
                            borderRadius: "10px",
                            opacity: isVisible ? 1 : 0,
                            transform: isVisible ? "translateY(0) scale(1)" : "translateY(30px) scale(0.9)",
                            transition: "all 1s ease 0.5s",
                        }}
                    >
                        <div style={{ textAlign: "center", marginBottom: "40px" }}>
                            <DesktopOutlined style={{ fontSize: "80px", color: "#FE7200", marginBottom: "20px" }} />
                            <Title level={2} style={{ fontSize: "32px", color: "#FFFFFF", marginBottom: "16px" }}>
                                Build Enterprise Apps Fast
                            </Title>
                            <Text style={{ fontSize: "18px", color: "rgba(255, 255, 255, 0.9)" }}>
                                Bring your ideas to life with powerful tools
                            </Text>
                        </div>

                        <Row gutter={[20, 20]}>
                            <Col span={24}>
                                <div style={{ 
                                    background: "rgba(255, 255, 255, 0.95)", 
                                    padding: "20px", 
                                    borderRadius: "12px",
                                    border: "1px solid rgba(255, 255, 255, 0.2)",
                                    backdropFilter: "blur(10px)",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "16px",
                                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)"
                                }}>
                                    <div style={{
                                        width: "48px",
                                        height: "48px",
                                        borderRadius: "12px",
                                        background: "rgba(254, 114, 0, 0.1)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}>
                                        <RocketOutlined style={{ fontSize: "24px", color: "#FE7200" }} />
                                    </div>
                                    <div>
                                        <Title level={5} style={{ color: "#FE7200", marginBottom: "4px", margin: 0 }}>
                                            Drag & Drop Builder
                                        </Title>
                                        <Text style={{ color: "#1D3557", fontSize: "14px" }}>
                                            Build apps fast with intuitive drag and drop tools
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div style={{ 
                                    background: "rgba(255, 255, 255, 0.95)", 
                                    padding: "20px", 
                                    borderRadius: "12px",
                                    border: "1px solid rgba(255, 255, 255, 0.2)",
                                    backdropFilter: "blur(10px)",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "16px",
                                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)"
                                }}>
                                    <div style={{
                                        width: "48px",
                                        height: "48px",
                                        borderRadius: "12px",
                                        background: "rgba(254, 114, 0, 0.1)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}>
                                        <ToolOutlined style={{ fontSize: "24px", color: "#FE7200" }} />
                                    </div>
                                    <div>
                                        <Title level={5} style={{ color: "#FE7200", marginBottom: "4px", margin: 0 }}>
                                            Custom Data Models
                                        </Title>
                                        <Text style={{ color: "#1D3557", fontSize: "14px" }}>
                                            Customize your data model with simple clicks
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div style={{ 
                                    background: "rgba(255, 255, 255, 0.95)", 
                                    padding: "20px", 
                                    borderRadius: "12px",
                                    border: "1px solid rgba(255, 255, 255, 0.2)",
                                    backdropFilter: "blur(10px)",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "16px",
                                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)"
                                }}>
                                    <div style={{
                                        width: "48px",
                                        height: "48px",
                                        borderRadius: "12px",
                                        background: "rgba(254, 114, 0, 0.1)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}>
                                        <SafetyOutlined style={{ fontSize: "24px", color: "#FE7200" }} />
                                    </div>
                                    <div>
                                        <Title level={5} style={{ color: "#FE7200", marginBottom: "4px", margin: 0 }}>
                                            Enterprise Security
                                        </Title>
                                        <Text style={{ color: "#1D3557", fontSize: "14px" }}>
                                            Stay protected with enterprise-grade security
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div style={{ 
                                    background: "rgba(255, 255, 255, 0.95)", 
                                    padding: "20px", 
                                    borderRadius: "12px",
                                    border: "1px solid rgba(255, 255, 255, 0.2)",
                                    backdropFilter: "blur(10px)",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "16px",
                                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)"
                                }}>
                                    <div style={{
                                        width: "48px",
                                        height: "48px",
                                        borderRadius: "12px",
                                        background: "rgba(254, 114, 0, 0.1)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}>
                                        <ApiOutlined style={{ fontSize: "24px", color: "#FE7200" }} />
                                    </div>
                                    <div>
                                        <Title level={5} style={{ color: "#FE7200", marginBottom: "4px", margin: 0 }}>
                                            Powerful APIs
                                        </Title>
                                        <Text style={{ color: "#1D3557", fontSize: "14px" }}>
                                            Integrate with anything using robust APIs
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Spin>
        </div>
    );
};

export default CreateOrg;
